import { useState } from "react";
import {
  activationFallbackSteps,
  activationSteps,
  frontPageGifs,
} from "lib/frontPageData";
import GuidePanel from "./GuidePanel";

export default function ActivationGuidePanel() {
  const [showFallback, setShowFallback] = useState(false);

  if (showFallback) {
    return (
      <div>
        <button
          type="button"
          onClick={() => setShowFallback(false)}
          className="mb-5 flex cursor-pointer items-center gap-2 rounded-md border border-[var(--dash-border)] px-4 py-2 text-sm text-[var(--dash-text)] transition-all hover:border-[var(--dash-text-strong)] hover:text-[var(--dash-text-strong)]"
        >
          <i className="fas fa-arrow-left" aria-hidden />
          Back
        </button>
        <GuidePanel
          heading="Activation Guide"
          steps={activationFallbackSteps}
          gifSrc={frontPageGifs.activation}
        />
      </div>
    );
  }

  return (
    <GuidePanel
      heading="Activation Guide"
      steps={activationSteps}
      footer={
        <p className="text-[0.95rem] leading-[1.7] text-[var(--dash-text-muted)]">
          <strong className="text-[var(--dash-text-strong)]">Note:</strong> In
          case you didn&apos;t receive the code in your email, please follow these
          steps:{" "}
          <button
            type="button"
            onClick={() => setShowFallback(true)}
            className="ml-1 inline-flex cursor-pointer items-center rounded-md bg-[var(--theme-accent)] px-3 py-1.5 align-middle text-sm font-semibold text-white transition-opacity hover:opacity-90"
          >
            Follow these steps
          </button>
        </p>
      }
    />
  );
}
